export default __webpack_public_path__ + "static/media/vinyl.560a543a.svg";